export default __webpack_public_path__ + "static/media/grid-inactive.f4ef550b.svg";